import APIKit from "../Allapis/Apikit/apikit";

// export const getProductPerformance = async (id, params) => {
//   let res;
//   let endpoint;
//   let { crmProductId, crmShareClassGuid, category, quarter, status } = params;
//   if (id) {
//     console.log(id);
//     endpoint = `/productPerformance/${id}`;
//     res = await APIKit.get(endpoint);
//   } else {
//     endpoint = `/productPerformance`;
//     res = await APIKit.get(endpoint, {
//       params: { crmProductId, crmShareClassGuid, category, quarter, status },
//     });
//   }
//   console.log(endpoint);
//   console.log(res, "res in api");
//   return res.data;
// };
export const getProductPerformance = async (id, params = {}) => {
  let res;
  let endpoint;

  const { crmProductId, crmShareClassGuid, category, quarter, status } = params;

  if (id) {
    endpoint = `/admin/productPerformance/${id}`;
    res = await APIKit.get(endpoint);
  } else {
    endpoint = `/admin/productPerformance`;
    res = await APIKit.get(endpoint, {
      params: {
        ...(crmProductId && { crmProductId }),
        ...(crmShareClassGuid && { crmShareClassGuid }),
        ...(category && { category }),
        ...(quarter && { quarter }),
        ...(status && { status }),
      },
    });
  }

  return res.data;
};

export const createProductPerformance = async (values) => {
  const res = await APIKit.post(`/admin/productPerformance`, values);
  return res.data;
};

export const updateProductPerformance = async (id, values) => {
  const res = await APIKit.put(`/admin/productPerformance/${id}`, values);
  return res.data;
};

export const deleteProductPerformance = async (prod_id) => {
  console.log(prod_id, "deleting id");
  const res = await APIKit.delete(`/admin/productPerformance/${prod_id}`);
  console.log(res, "delete response");
  return res.data;
};
